export default {
  path: '/day-trips',
  component: () => import('@/views/day-trips/Index'),
  redirect: { name: 'day-trips-groups-list' },
  children: [
    {
      path: 'groups',
      component: () => import('@/views/day-trips/groups/Index'),
      children: [
        {
          path: '',
          name: 'day-trips-groups-list',
          component: () => import('@/views/day-trips/groups/List'),
          meta: {
            title: 'Groups list',
            roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
          }
        },
        {
          path: ':id',
          name: 'day-trips-groups-detail',
          component: () => import('@/views/day-trips/groups/Detail'),
          meta: {
            title: 'Group name (0) ID: 0',
            roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
          }
        }
      ]
    }
  ]
}